interface NotFoundViewProps {
  path: string;
}

export default function NotFoundView({ path }: NotFoundViewProps) {
  return (
    <div className="not-configured" data-testid="not-found-view">
      <h2 style={{ marginTop: 0 }}>Page not found</h2>
      <p>
        Nothing exists at <code>{path}</code>.
      </p>
    </div>
  );
}
